
import React from "react";

const whatsapp =
  "https://wa.me/5588988785373?text=" +
  encodeURIComponent(
    "Olá! Conheci a iSolution pelo site e gostaria de conversar sobre um projeto."
  );

function Footer() {
  const ano = new Date().getFullYear();

  return (
    <footer id="contato" className="footer">
      <div className="container">
        <div className="footer-principal">
          <div className="footer-apresentacao">
            <span className="sobretitulo sobretitulo-claro">
              VAMOS CONVERSAR?
            </span>

            <h2>
              Sua próxima grande ideia começa com uma conversa.
            </h2>

            <p>
              Conte para nós o que você precisa. Vamos entender seu
              desafio e encontrar o melhor caminho para transformá-lo
              em uma solução digital.
            </p>

            <a
              href={whatsapp}
              className="footer-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp" aria-hidden="true" />
              Conversar pelo WhatsApp
              <span aria-hidden="true">↗</span>
            </a>

            <a
              className="footer-email"
              href="mailto:isolutionsistemas@gmail.com"
            >
              <i className="far fa-envelope" aria-hidden="true" />
              isolutionsistemas@gmail.com
            </a>
          </div>

          <div className="footer-formulario">
            <h3>Envie sua mensagem</h3>
            <p>Preencha os campos e conte um pouco sobre seu projeto.</p>

            <form
              action="mailto:isolutionsistemas@gmail.com"
              method="post"
              encType="text/plain"
            >
              <label htmlFor="nome">Nome</label>
              <input
                type="text"
                id="nome"
                name="Nome"
                placeholder="Como podemos chamar você?"
                autoComplete="name"
                required
              />

              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                name="E-mail"
                placeholder="seuemail@exemplo.com"
                autoComplete="email"
                required
              />

              <label htmlFor="mensagem">Como podemos ajudar?</label>
              <textarea
                id="mensagem"
                name="Mensagem"
                rows="4"
                placeholder="Conte um pouco sobre sua ideia ou necessidade..."
                required
              />

              <button type="submit" className="footer-enviar">
                Enviar mensagem <span aria-hidden="true">↗</span>
              </button>
            </form>

            <small>
              O envio pelo formulário depende de um aplicativo de e-mail
              configurado no dispositivo.
            </small>
          </div>
        </div>

        <div className="footer-redes">
          <div className="footer-marca">
            <strong>iSolution<span>.</span></strong>
            <p>Tecnologia que transforma ideias em soluções.</p>
          </div>

          <div className="footer-links">
            <a
              href="https://www.instagram.com/isolution.software/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram da iSolution"
            >
              <i className="fab fa-instagram" />
            </a>

            <a
              href="https://www.facebook.com/admDaviLemosRocha"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <i className="fab fa-facebook-f" />
            </a>

            <a
              href="mailto:isolutionsistemas@gmail.com"
              aria-label="Enviar e-mail"
            >
              <i className="far fa-envelope" />
            </a>
          </div>
        </div>

        <div className="footer-final">
          <p>© {ano} iSolution. Todos os direitos reservados.</p>
          <a href="#banner">Voltar ao topo ↑</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
